import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import { Dialog, DialogActions, DialogContent, DialogTitle, Paper } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import request from "superagent";
import { defaultPaperPadding, url_endpoint } from "../../../config";
import authHeader from "../../Utils/AuthHeader";
import { Redirect } from "react-router-dom";
import LinearProgress from '@material-ui/core/LinearProgress';
import LinkIcon from '@material-ui/icons/Link';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import rehypeRaw from 'rehype-raw'

const styles = (theme) => ({
    input_hidde: {
        display: 'none'
    }
});

class NewPostcast extends Component {

    constructor(props) {
        super(props);
        this.state = {
            nome: "",
            texto: "",
            descricaoAgregadores: '',
            imagem: "",
            toPosts: false,
            loading_percent: 0,
            erro: false,
            imageValid: true,
            openAddLinkDialog: false,
            openPreviewDialog: false,
            tempLinkName: '',
            tempLinkUrl: '',
        }

        props.setTitulo('Novo Áudio');
    }

    tempo(palavras) {
        const tempo = palavras / 145;
        const minutes = Math.floor(tempo);
        const seconds = Math.floor((tempo - minutes) * 60);
        let medida;
        if (minutes > 0) {
            medida = minutes + '.' + seconds + 'min';
        }
        if (minutes == 0) {
            medida = seconds + 's';
        }
        return medida;
    }

    enviaPedido = async () => {
        if (this.state.loading_percent > 0) return;
        if (this.state.nome === "" || this.state.texto === "") {
            this.setState({ error: true })
            return;
        } else if (!this.state.imageValid) {
            alert("Informe uma imagem JPG e com tamanho mínimo 1400x1400px !")
            return;
        }
        try {
            const res = await request.post(url_endpoint + "pedido")
                .attach("imagem", this.state.imagem)
                .field("titulo", this.state.nome)
                .field("descricao_agregadores", this.state.descricaoAgregadores)
                .field("post", this.state.texto).set(authHeader())
                .on('progress', event => {
                    this.setState({ loading_percent: event.percent })
                })
            this.setState({ toPosts: true });
        } catch (err) {
            alert(err.response.text);
        }
    }

    readImage = () => {
        const scope = this
        if (this.state.imagem) {
            var img = document.createElement("img");
            this.setState({ imageValid: true });

            img.onload = function () {

                if (this.width < 1400 || this.height < 1400) {
                    scope.setState({ imageValid: false });
                } else {
                    scope.setState({ imageValid: true });
                }
            };

            var reader = new FileReader();
            reader.onloadend = function (ended) {
                img.src = ended.target.result;
            }
            reader.readAsDataURL(this.state.imagem);
        }
    }
    onChangeImageCapa = async (evt) => {
        await this.setState({ imagem: evt.target.files[0] });
        this.readImage()
    }

    handleClose = () => {
        this.setState({ openAddLinkDialog: false, openPreviewDialog: false });
    };

    render() {
        const { classes } = this.props;

        if (this.state.toPosts === true) {
            return <Redirect to='/painel' />
        }
        const palavras = this.state.texto.split(/\n| /);
        return (
            <Grid container spacing={0}>
                {this.state.loading_percent > 0 &&
                    <LinearProgress variant="determinate" value={this.state.loading_percent} style={{ width: "100%", height: 3 }} />
                }
                <Dialog
                    open={this.state.openAddLinkDialog}
                    onClose={this.handleClose}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
                        {"Adicionar link"}
                    </DialogTitle>
                    <DialogContent>
                        <p style={{ fontSize: '18px' }}>Ao adicionar um link, um trecho de código será adicionado à descrição, por favor note que caso este trecho seja editado pode afetar a funcionalidade nos agregadores.</p>
                        <br />
                        <TextField
                            label="Texto do link"
                            margin="normal"
                            style={{ width: '100%' }}
                            onChange={evt => this.setState({ tempLinkName: evt.target.value })}
                        />
                        <br />
                        <TextField
                            label="Endereço do link"
                            margin="normal"
                            style={{ width: '100%' }}
                            onChange={evt => this.setState({ tempLinkUrl: evt.target.value })}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            this.setState({ tempLinkName: '', tempLinkUrl: '' })
                            this.handleClose()
                        }} color="red">
                            {"Cancelar"}
                        </Button>
                        <Button onClick={() => {
                            this.setState({ descricaoAgregadores: this.state.descricaoAgregadores + `<a href="${this.state.tempLinkUrl}" target="_blank">${this.state.tempLinkName}</a>` })
                            this.handleClose()
                        }} color="primary">
                            {"Adicionar"}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.openPreviewDialog}
                    onClose={this.handleClose}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
                        {"Visualizar descrição"}
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={0} style={{ fontSize: '16px' }}>
                            <ReactMarkdown linkTarget={'_blank'} rehypePlugins={[rehypeRaw]} children={this.state.descricaoAgregadores}></ReactMarkdown>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            {"OK"}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Paper style={{ padding: defaultPaperPadding, width: "100%" }}>
                    <Grid container spacing={0}>
                        <Grid xs={12} sm={8}>
                            <TextField
                                error={this.state.error && this.state.nome === ""}
                                label="Título"
                                value={this.state.nome}
                                onChange={evt => this.setState({ nome: evt.target.value })}
                                margin="normal"
                                style={{ marginTop: 0, width: "100%", paddingRight: 20 }}
                            />
                        </Grid>
                        <Grid xs={12} sm={3}>

                            <input
                                accept="image/jpeg, image/png"
                                className={classes.input_hidde}
                                id="icon-button-photo"
                                onChange={evt => this.onChangeImageCapa(evt)}
                                type="file"
                            />

                            <div style={{ color: "#6d6d6d", fontSize: 11, marginBottom: 0 }}>{this.state.imagem.name}</div>

                            <label htmlFor="icon-button-photo">
                                <Button variant="contained" color="primary" component="span">
                                    {"Imagem do Episódio"}
                                </Button>
                            </label>
                            <div style={{ color: this.state.imageValid ? '#000' : "#ff0000", fontSize: 14, marginBottom: 0 }}>{this.state.imageValid ? "A imagem precisa ter no mínimo 1400x1400." : "Imagem fora dos padrões! A imagem precisa ter no mínimo 1400x1400."}</div>

                        </Grid>

                    </Grid>
                    <Grid container spacing={0}>
                        <TextField
                            id="standard-multiline-flexible"
                            label="Texto"
                            error={this.state.error && this.state.texto === ""}
                            multiline
                            style={{ width: "100%" }}
                            margin="normal"
                            onChange={evt => this.setState({ texto: evt.target.value })}
                            value={this.state.texto}
                        />
                        <div style={{ width: "100%", textAlign: "right", fontSize: 18, color: "#6f6f6f" }}>{palavras.length - 1} palavra{palavras.length - 1 > 1 && <span>s</span>} (cerca de {this.tempo(palavras.length - 1)})</div>
                    </Grid>
                    <Grid container spacing={0}>
                        <TextField
                            id="standard-multiline-flexible"
                            label="Descrição para Agregadores (Opcional)"
                            multiline
                            style={{ width: "100%" }}
                            margin="normal"
                            onChange={evt => this.setState({ descricaoAgregadores: evt.target.value })}
                            value={this.state.descricaoAgregadores}
                        />
                        <div style={{ marginBottom: '10px', width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                startIcon={<LinkIcon />}
                                onClick={() => { this.setState({ openAddLinkDialog: true }) }}
                            >
                                Adicionar Link
                            </Button>
                            {
                                (this.state.descricaoAgregadores.length > 0) &&
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    onClick={() => { this.setState({ openPreviewDialog: true }) }}
                                >
                                    Visualizar descrição
                                </Button>
                            }
                        </div>
                    </Grid>
                    <Button variant="contained" color="primary" onClick={this.enviaPedido}>
                        {this.state.loading_percent == 0 ? "Enviar pedido de Áudio" : "Carregando..."}
                    </Button>
                </Paper>
            </Grid>
        )
    }
}


export default withStyles(styles, { withTheme: true })(NewPostcast);